// JS Controller for global methods and functions 

import { Controller } from "stimulus"
import Choices from "choices.js"

const RESUME_PART_FIELD_IDS = [
  "article_resume_part1",
  "article_resume_part2",
  "article_resume_part3",
  "article_resume_part4",
  "article_resume_part5"
]

const RESUME_PART_LABELS = {
  article_resume_part1: "Introdução",
  article_resume_part2: "Objetivo",
  article_resume_part3: "Métodos",
  article_resume_part4: "Resultados/discussão",
  article_resume_part5: "Conclusão"
}

export default class extends Controller {

  static targets = [ "authors", "shortResume", "extendedResume", "monographyResume", "shortResumeLimit", "extendedResumeLimit", "monographyResumeLimit", "shortResumeMaxSize", "extendedResumeMaxSize", "wordsSize", "monographyResumeMaxSize", "eventEditionId", "articleModalityIds"]
  static values = [ "resumeEditor" ]
  
  connect() {
    if (document.body.getAttribute("data-action").includes("new")) {
      this.hideOrShowResumeField(document.getElementById("article_article_type").value)
      this.hideOrShowResumeTargets(document.getElementById("article_article_type").value)
      this.loadArticleModalities(document.getElementById("article_article_type").value)
      this.loadCKEditor()
    }

    if (document.querySelector("#article_keywords")) {
      this.loadArticleKeywords()
    }
  }

  loadArticleModalities(value){  
    self = this    
    if (document.querySelector('#article_article_modality_ids')){    
      self.articleModalityIdsTarget.innerHTML = ""  
      if (value != ''){                    
        fetch(
          "/modalidades-de-resumos/listar-todos?event_edition_id=" + self.eventEditionIdTarget.dataset.value + "&article_type=" + value
        )
        .then(function(response) {
          return response.json()
        })
        .then(function(data) {
          data.map(function(articleModality) {
            self.articleModalityIdsTarget.insertAdjacentHTML('beforeend', `
              <option value="${articleModality.value}">${articleModality.label}</option>
            `)
          })
        })
      }     
    }
  }
  hideOrShowResumeField(value) {    
    if (document.querySelector(".messages")) {
      document.querySelector(".messages").innerHTML = ""
    }      
    if (document.querySelector("#article_archive")) {
      var enableShortResumePdf = document.querySelector("#article_archive").dataset.enableShortResumePdf
      var enableExtendedResumePdf = document.querySelector("#article_archive").dataset.enableExtendedResumePdf
      var enableMonographyPdf = document.querySelector("#article_archive").dataset.enableMonographyPdf
    }
    if (value == "0") {
      if (enableShortResumePdf == "true") {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.add("is-display-block")
          document.querySelector("#article_archive_label").classList.remove("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.add("is-display-none")
          document.querySelector("#article_resume_label").classList.add("is-display-none")
        }
      } else {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.remove("is-display-block")
          document.querySelector("#article_archive_label").classList.add("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.remove("is-display-none")
          document.querySelector("#article_resume_label").classList.remove("is-display-none")
        }
      }
    } else if (value == "1") {
      if (enableExtendedResumePdf == "true") {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.add("is-display-block")
          document.querySelector("#article_archive_label").classList.remove("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.add("is-display-none")
          document.querySelector("#article_resume_label").classList.add("is-display-none")
        }
      } else {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.remove("is-display-block")
          document.querySelector("#article_archive_label").classList.add("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.remove("is-display-none")
          document.querySelector("#article_resume_label").classList.remove("is-display-none")
        }
      }
    } else if (value == "2") {
      if (enableMonographyPdf == "true") {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.add("is-display-block")
          document.querySelector("#article_archive_label").classList.remove("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.add("is-display-none")
          document.querySelector("#article_resume_label").classList.add("is-display-none")
        }
      } else {
        if (document.querySelector("#article_archive")) {
          document.querySelector("#article_archive").classList.remove("is-display-block")
          document.querySelector("#article_archive_label").classList.add("is-display-none")
        }
        if (document.querySelector("#article_resume_field")) {
          document.querySelector("#article_resume_field").classList.remove("is-display-none")
          document.querySelector("#article_resume_label").classList.remove("is-display-none")
        }
      }
    }
  }

  hideOrShowResumeTargets(value) {
    if (value == ''){
      this.shortResumeTarget.classList.add("is-display-none")
      this.extendedResumeTarget.classList.add("is-display-none")
      this.monographyResumeTarget.classList.add("is-display-none")
    } else if (value == "0") {
      this.shortResumeTarget.classList.remove("is-display-none")
      this.extendedResumeTarget.classList.add("is-display-none")
      this.monographyResumeTarget.classList.add("is-display-none")
      if (this.hasShortResumeLimitTarget)
        this.shortResumeLimitTarget.classList.remove("is-display-none")
      if (this.hasExtendedResumeLimitTarget)
        this.extendedResumeLimitTarget.classList.add("is-display-none")
      if (this.hasMonographyResumeLimitTarget)
        this.monographyResumeLimitTarget.classList.add("is-display-none")
      if (document.getElementById("kind"))
        document.getElementById("kind").value = 0
    } else if (value == "1") {
      this.extendedResumeTarget.classList.remove("is-display-none")
      this.shortResumeTarget.classList.add("is-display-none")      
      this.monographyResumeTarget.classList.add("is-display-none")
      if (this.hasExtendedResumeLimitTarget)
        this.extendedResumeLimitTarget.classList.remove("is-display-none")
      if (this.hasShortResumeLimitTarget)
        this.shortResumeLimitTarget.classList.add("is-display-none")      
      if (this.hasMonographyResumeLimitTarget)
        this.monographyResumeLimitTarget.classList.add("is-display-none")
      if (document.getElementById("kind"))
        document.getElementById("kind").value = 1
    } else if (value == "2") {
      this.monographyResumeTarget.classList.remove("is-display-none")
      this.shortResumeTarget.classList.add("is-display-none")
      this.extendedResumeTarget.classList.add("is-display-none")  
      if (this.hasMonographyResumeLimitTarget)
        this.monographyResumeLimitTarget.classList.remove("is-display-none")    
      if (this.hasShortResumeLimitTarget)
        this.shortResumeLimitTarget.classList.add("is-display-none")
      if (this.hasExtendedResumeLimitTarget)
        this.extendedResumeLimitTarget.classList.add("is-display-none")      
      if (document.getElementById("kind"))
        document.getElementById("kind").value = 2
    }
  }

  addAuthor(event) {
    if (!(this.countAuthorsFields() >= 22)){
      var divItem = document.createElement("div")
      divItem.classList.add("item")
      var divFlex1 = document.createElement("div")
      divFlex1.classList.add("flex")
      var formGroup1 = document.createElement("div")
      formGroup1.classList.add("flex-item")
      formGroup1.classList.add("form-group")
      var input1 = document.createElement("input")
      input1.type = "text"
      input1.name = "article[names][]"
      input1.placeholder = (this.countAuthorsFields() + 2) + "º Autor (nome completo)"
      formGroup1.appendChild(input1)
      divFlex1.appendChild(formGroup1)
      var divFlex2 = document.createElement("div")
      divFlex2.classList.add("flex")
      var formGroup2 = document.createElement("div")
      formGroup2.classList.add("flex-item")
      formGroup2.classList.add("form-group")
      var input2 = document.createElement("input")
      input2.type = "text"
      input2.placeholder = (this.countAuthorsFields() + 2) + "º Instituição"
      input2.name = "article[institutions][]"
      formGroup2.appendChild(input2)
      var formGroup3 = document.createElement("div")
      formGroup3.classList.add("flex-item")
      formGroup3.classList.add("form-group")
      var input3 = document.createElement("input")
      input3.name = "article[emails][]"
      input3.type = "email"
      input3.placeholder = (this.countAuthorsFields() + 2) + "º Email"
      formGroup3.appendChild(input3)      
      var formGroup4 = document.createElement("div")
      formGroup4.classList.add("flex-item")
      formGroup4.classList.add("form-group")
      var input4 = document.createElement("input")
      input4.name = "article[whatsapp_numbers][]"
      input4.type = "text"
      input4.placeholder = (this.countAuthorsFields() + 2) + "º Whatsapp"
      formGroup4.appendChild(input4)
      divFlex2.appendChild(formGroup2)
      divFlex2.appendChild(formGroup3)
      divFlex2.appendChild(formGroup4)
      divItem.appendChild(divFlex1)
      divItem.appendChild(divFlex2)
      this.authorsTarget.append(divItem)
    }
  }

  removeAuthor(event) {
    const child = this.authorsTarget.lastElementChild
    if (child == null) {
      return false
    } else {
      this.authorsTarget.lastElementChild.remove()
    }
  }

  countAuthorsFields(){
    return this.authorsTarget.getElementsByClassName('item').length
  }

  changeArticleType(event) {
    this.hideOrShowResumeField(event.target.value)
    this.hideOrShowResumeTargets(event.target.value)
    this.loadArticleModalities(event.target.value)
    this.loadCKEditor()

  }

  loadArticleKeywords() {
    let config = {
      searchResultLimit: 15,
      searchChoices: false,
      position: "bottom",
      removeItems: true,
      removeItemButton: true,
      sorter: function() { return },
      noChoicesText: 'Nenhum item para ser selecionado',
      itemSelectText: "Pressione enter para adicionar",
      loadingText: "Carregando..."
    }
    let input = document.querySelector("#article_keywords")
    let choice = new Choices(input, config)
    let inputDup = input.parentElement.getElementsByClassName("choices__input--cloned")[0]
    let keyboardEnter = new KeyboardEvent('keydown', {
      code: 'Enter',
      key: 'Enter',
      charKode: 13,
      keyCode: 13,
      view: window
    });
    inputDup.addEventListener('keyup', function(event) {
      let newValue = event.target.value.slice(0, -1)
      if (event.keyCode == 188 || event.keyCode == 186 || event.keyCode == 190) {
        event.target.value = newValue
        inputDup.dispatchEvent(keyboardEnter)
      }
    })
    inputDup.addEventListener('paste', function(event) {
      setTimeout(function(e) {
        event.target.value.split(/\s*,\s*|\s*;\s*|\s*\.\s*/).forEach(function(item){
          event.target.value = item
          inputDup.dispatchEvent(keyboardEnter)
        });
      }, 1);
    })
  }

  validateResumePartsBeforeSubmit(event) {
    if (!document.getElementById("article_resume_part1")) return

    this.syncResumePartsToTextareas()
    const errors = this.duplicateResumePartErrors()
    if (errors.length === 0) return

    event.preventDefault()
    event.stopImmediatePropagation()
    this.showResumePartValidationErrors(errors)
  }

  syncResumePartsToTextareas() {
    RESUME_PART_FIELD_IDS.forEach(id => {
      const editor = CKEDITOR.instances[id]
      if (editor) editor.updateElement()
    })
  }

  normalizeResumePartContent(content) {
    if (!content) return ""

    const container = document.createElement("div")
    container.innerHTML = content
    return (container.textContent || container.innerText || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
  }

  getResumePartContent(fieldId) {
    const editor = CKEDITOR.instances[fieldId]
    if (editor) return editor.getData()

    const field = document.getElementById(fieldId)
    return field ? field.value : ""
  }

  duplicateResumePartErrors() {
    const errors = []
    const seen = new Map()

    RESUME_PART_FIELD_IDS.forEach(id => {
      if (!document.getElementById(id)) return

      const normalized = this.normalizeResumePartContent(this.getResumePartContent(id))
      if (!normalized) return

      const label = RESUME_PART_LABELS[id]
      if (seen.has(normalized)) {
        errors.push(
          `As seções ${seen.get(normalized)} e ${label} possuem o mesmo conteúdo. Cada parte do resumo deve ser única.`
        )
      } else {
        seen.set(normalized, label)
      }
    })

    return [...new Set(errors)]
  }

  showResumePartValidationErrors(errors) {
    const formErrors = document.querySelector('[data-target="application.formErrors"]')
    if (!formErrors) return

    formErrors.innerHTML = ""
    errors.forEach(error => {
      const li = document.createElement("li")
      li.classList.add("error")
      li.appendChild(document.createTextNode(error))
      formErrors.appendChild(li)
    })

    document.getElementById("articles-form").scrollIntoView({ behavior: "smooth", block: "start" })
  }

  loadCKEditor() {
    const resumePartFieldIds = RESUME_PART_FIELD_IDS

    const resumeFields = ["article_resume", ...resumePartFieldIds];

    if (!resumeFields.some(id => document.getElementById(id))) return;

    const isSegmentedResume = () => !!document.getElementById("article_resume_part1");

    const getActiveResumeFieldIds = () => {
        if (isSegmentedResume()) {
            return resumePartFieldIds.filter(id => document.getElementById(id));
        }

        return ["article_resume"].filter(id => document.getElementById(id));
    };

    let wordMaxLimit = 0;
    let insertConfig = [];
    let articleType = document.getElementById("article_article_type")?.value;

    if (articleType === "0") {
        wordMaxLimit = parseInt(this.shortResumeMaxSizeTarget.getAttribute("data-value"));
    } else if (articleType === "1" || articleType === "2") {
        wordMaxLimit = parseInt((articleType === "1" ? this.extendedResumeMaxSizeTarget : this.monographyResumeMaxSizeTarget)
            .getAttribute("data-value"));
        insertConfig = ['base64image', 'Table'];
    }

    const countTotalWords = () => {
        let totalWords = 0;
        getActiveResumeFieldIds().forEach(id => {
            const editor = CKEDITOR.instances[id];
            if (editor) {
                const text = editor.getData().replace(/<[^>]+>/g, '').trim();
                const words = text.split(/\s+/).filter(word => word.length > 0);
                totalWords += words.length;
            }
        });
        return totalWords;
    };

    const checkBeforeInsert = (evt) => {
        const currentWords = countTotalWords();
        let addedWords = 0;

        if (evt.data && evt.data.html) {
            const addedText = evt.data.html.replace(/<[^>]+>/g, '').trim();
            addedWords = addedText.split(/\s+/).filter(word => word.length > 0).length;
        } else if (evt.data && evt.data.dataValue) {
            const addedText = evt.data.dataValue.replace(/<[^>]+>/g, '').trim();
            addedWords = addedText.split(/\s+/).filter(word => word.length > 0).length;
        }

        if (currentWords + addedWords > wordMaxLimit) {
            alert(`Limite de ${wordMaxLimit} palavras excedido! Remova ${(currentWords + addedWords) - wordMaxLimit} palavras.`);
            evt.cancel();
            return false;
        }
        return true;
    };

    const blockTypingIfLimitReached = (evt) => {
      const currentWords = countTotalWords();
      
      const isControlKey = (
          evt.data.keyCode === 8 ||   // Backspace
          evt.data.keyCode === 46 ||  // Delete
          evt.data.keyCode === 37 ||  // Seta esquerda
          evt.data.keyCode === 38 ||  // Seta cima
          evt.data.keyCode === 39 ||  // Seta direita
          evt.data.keyCode === 40 ||  // Seta baixo
          evt.data.keyCode === 9 ||    // Tab
          (evt.data.ctrlKey && (evt.data.keyCode === 86 || evt.data.keyCode === 67 || evt.data.keyCode === 88)) 
      );
  
      if (currentWords >= wordMaxLimit && !isControlKey) {
          evt.cancel();
          alert(`Limite de ${wordMaxLimit} palavras atingido! Não é possível adicionar mais texto.`);
          return false;
      }
  
      if (currentWords < wordMaxLimit && !isControlKey) {
          const editor = evt.editor;
          const currentText = editor.getData().replace(/<[^>]+>/g, '').trim();
          const currentWordCount = currentText.split(/\s+/).filter(word => word.length > 0).length;
  
          if (evt.data.keyCode === 32 || (evt.data.keyCode >= 65 && evt.data.keyCode <= 90)) { 
              const newTotalWords = currentWords + 1; 
              if (newTotalWords > wordMaxLimit) {
                  evt.cancel();
                  alert(`Limite de ${wordMaxLimit} palavras será excedido! Remova ${currentWords + 1 - wordMaxLimit} palavras.`);
                  return false;
              }
          }
      }
  
      return true;
  };

    let config = {
        customConfig: '/js/ckeditor_config.js',
        toolbar: [
            { name: 'clipboard', items: ['Undo', 'Redo'] },
            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
            { name: 'align', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
            { name: 'links', items: ['Link', 'Unlink'] },
            { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent'] },
            { name: 'insert', items: insertConfig },
            { name: 'editing', items: ['Scayt'] }
        ],
        wordcount: {
            showWordCount: true,
            showCharCount: false,
            maxWordCount: wordMaxLimit,
            ...(isSegmentedResume() ? {
                getWordCount: () => countTotalWords(),
                hardLimit: false
            } : {})
        },
        on: {
            beforePaste: checkBeforeInsert,  // Valida antes de colar
            beforeDrop: checkBeforeInsert,   // Valida antes de arrastar e soltar
            insertHtml: checkBeforeInsert,   // Valida antes de inserir HTML
            key: blockTypingIfLimitReached,  // Bloqueia digitação se limite atingido
            afterCommandExec: (evt) => {     // Valida comandos como inserir tabela/imagem
                if (['insertTable', 'image', 'base64image'].includes(evt.data.command.name)) {
                    if (countTotalWords() > wordMaxLimit) {
                        alert(`Limite de ${wordMaxLimit} palavras excedido!`);
                    }
                }
            }
        }
    };

    resumeFields.forEach(id => {
        if (CKEDITOR.instances[id]) {
            CKEDITOR.instances[id].destroy();
        }
        if (document.getElementById(id)) {
            CKEDITOR.replace(id, config);
        }
    });

    if (isSegmentedResume()) {
        let syncWordCountTimeout;

        const syncAllWordCounters = () => {
            getActiveResumeFieldIds().forEach(id => {
                const editor = CKEDITOR.instances[id];
                if (editor) editor.fire("updateWordCount");
            });
        };

        const scheduleSyncAllWordCounters = () => {
            clearTimeout(syncWordCountTimeout);
            syncWordCountTimeout = setTimeout(syncAllWordCounters, 260);
        };

        getActiveResumeFieldIds().forEach(id => {
            const editor = CKEDITOR.instances[id];
            if (!editor) return;

            editor.on("change", scheduleSyncAllWordCounters);
            editor.on("dataReady", syncAllWordCounters);
        });
    }
  }
}
